import { render, staticRenderFns } from "./QuickAddWizard.vue?vue&type=template&id=a5188be8&scoped=true"
import script from "./QuickAddWizard.vue?vue&type=script&lang=js"
export * from "./QuickAddWizard.vue?vue&type=script&lang=js"
import style0 from "./QuickAddWizard.vue?vue&type=style&index=0&id=a5188be8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5188be8",
  null
  
)

export default component.exports